const createActions = Object.freeze([
    "create",
    "new",
]);

const getActions = Object.freeze([
    "get",
    "read",
    "show",
]);

const updateActions = Object.freeze([
    "edit",
    "update",
    "change",
]);

const deleteActions = Object.freeze([
    "delete",
    "remove",
]);

const listActions = Object.freeze([
    "index",
    "list",
]);

const crudActions = Object.freeze([
    ...createActions,
    ...getActions,
    ...updateActions,
    ...deleteActions,
]);

const readOnlyActions = Object.freeze([
    ...getActions,
    ...deleteActions,
]);

const submitActions = Object.freeze([
    ...createActions,
    ...updateActions,
    ...deleteActions,
]);

const nonDestructiveSubmitActions = Object.freeze([
    ...createActions,
    ...updateActions,
]);

function isValidCrudAction(action) {
    return crudActions.includes(action);
}

function isValidCreateAction(action) {
    return createActions.includes(action);
}

function isValidGetAction(action) {
    return getActions.includes(action);
}

function isValidUpdateAction(action) {
    return updateActions.includes(action);
}

function isValidDeleteAction(action) {
    return deleteActions.includes(action);
}

function isValidListAction(action) {
    return listActions.includes(action);
}

function isValidReadonlyAction(action) {
    return readOnlyActions.includes(action);
}

function isValidSubmitAction(action) {
    return submitActions.includes(action);
}

function isValidNonDestructiveSubmitAction(action) {
    return nonDestructiveSubmitActions.includes(action);
}

function isIllegalCrudAction(action) {
    return !isValidCrudAction(action);
}


function isIllegalCreateAction(action) {
    return !isValidCreateAction(action);
}

function isIllegalGetAction(action) {
    return !isValidGetAction(action);
}

function isIllegalDeleteAction(action) {
    return !isValidDeleteAction(action);
}

function isIllegalListAction(action) {
    return !isValidListAction(action);
}

function isIllegalUpdateAction(action) {
    return !isValidUpdateAction(action);
}

function isIllegalReadonlyAction(action) {
    return !isValidReadonlyAction(action);
}

function isIllegalSubmitAction(action) {
    return !isValidSubmitAction(action);
}

function isIllegalNonDestructiveAction(action) {
    return !isValidNonDestructiveSubmitAction(action);
}

function throwOnIllegalCrudAction(action) {
    if(isIllegalCrudAction(action)) {
        throw new RangeError(`Illegal value for 'CRUD' action ('${action}'), must be one of: ${crudActions.join(", ")}.`);
        
    }
}

function throwOnIllegalCreateAction(action) {
    if(isIllegalCreateAction(action)) {
        throw new RangeError(`Illegal value for 'Create' action ('${action}'), must be one of: ${createActions.join(", ")}.`);
        
    }
}

function throwOnIllegalGetAction(action) {
    if(isIllegalGetAction(action)) {
        throw new RangeError(`Illegal value for 'Get' action ('${action}'), must be one of: ${getActions.join(", ")}.`);
    }
}


function throwOnIllegalDeleteAction(action) {
    if(isIllegalDeleteAction(action)) {
        throw new RangeError(`Illegal value for 'Delete' action ('${action}'), must be one of: ${deleteActions.join(", ")}.`);
    }
}

function throwOnIllegalListAction(action) {
    if(isIllegalListAction(action)) {
        throw new RangeError(`Illegal value for 'List' action ('${action}'), must be one of: ${listActions.join(", ")}.`);
    }
}

function throwOnIllegalUpdateAction(action) {
    if(isIllegalUpdateAction(action)) {
        throw new RangeError(`Illegal value for 'Update' action ('${action}'), must be one of: ${updateActions.join(", ")}.`);
    }
}

function throwOnIllegalReadonlyAction(action) {
    if(isIllegalReadonlyAction(action)) {
        throw new RangeError(`Illegal value for 'Readonly' action ('${action}'), must be one of: ${readOnlyActions.join(", ")}.`);
    }
}

function throwOnIllegalSubmitAction(action) {
    if(isIllegalSubmitAction(action)) {
        throw new RangeError(`Illegal value for 'Submittable' action ('${action}'), must be one of: ${submitActions.join(", ")}.`);
    }
}

function throwOnIllegalNonDestructiveSubmitAction(action) {
    if(isIllegalNonDestructiveAction(action)) {
        throw new RangeError(`Illegal value for 'Non-destructive Submit' action ('${action}'), must be one of: ${nonDestructiveSubmitActions.join(", ")}.`);
    }
}

export default {
    createActions,
    getActions,
    updateActions,
    deleteActions,
    listActions,
    crudActions,
    readOnlyActions,
    submitActions,
    nonDestructiveSubmitActions,
    isValidCrudAction,
    isValidCreateAction,
    isValidGetAction,
    isValidDeleteAction,
    isValidUpdateAction,
    isValidReadonlyAction,
    isValidSubmitAction,
    isValidNonDestructiveSubmitAction,
    isIllegalCreateAction,
    isIllegalCrudAction,
    isIllegalDeleteAction,
    isIllegalGetAction,
    isIllegalListAction,
    isIllegalReadonlyAction,
    isIllegalSubmitAction,
    isIllegalNonDestructiveAction,
    throwOnIllegalCreateAction,
    throwOnIllegalCrudAction,
    throwOnIllegalDeleteAction,
    throwOnIllegalGetAction,
    throwOnIllegalListAction,
    throwOnIllegalUpdateAction,
    throwOnIllegalReadonlyAction,
    throwOnIllegalSubmitAction,
    throwOnIllegalNonDestructiveSubmitAction,
};